import {IComponentController} from "angular";
import {ACTION_SERVICE_NAME, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {OpportunityAction} from "../../model/OpportunityAction";
import {ActionService} from "../../../opportunity_actions_service/service/ActionService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

export class CancelMailDialogComponent implements IComponentController {

    public static instance = (opportunityAction: OpportunityAction): angular.material.IDialogOptions => ({
        template: require('./cancel.mail.dialog.component.html'),
        controller: ['$mdDialog', ACTION_SERVICE_NAME,ToastNotificationServiceName, 'opportunityAction', CancelMailDialogComponent],
        controllerAs: 'ctrl',
        multiple: true,
        locals: {
            opportunityAction: opportunityAction
        }
    });


    constructor(private $mdDialog: angular.material.IDialogService,
                protected actionService: ActionService,
                private toastNotificationSerivce: ToastNotificationService,
                private opportunityAction: OpportunityAction) {

    }

    private cancel = () => {
        this.$mdDialog.cancel();
    };

    private cancelMail = () => {
        return this.actionService.cancelAction(this.opportunityAction).then(resp => {
                if (resp.status === 200) {
                    this.toastNotificationSerivce.generateSuccessMessage('Mail was canceled');
                    this.$mdDialog.hide();
                } else {
                    this.toastNotificationSerivce.generateSuccessMessage('Mails wasn\'t cancelled');
                    this.$mdDialog.cancel();
                }
        });
    }
}